const category = [
    {
        display: "T-shirt",
        categorySlug: "ao-thun"
    },
    {
        display: "Shirt",
        categorySlug: "ao-somi"
    },
    {
        display: "Jeans",
        categorySlug: "Mandarin jean"
    }
]

export default category